/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Schwerbehinderungid2Inputs */



/**

* @param {_Field_Schwerbehinderungid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_schwerbehinderungid2 = /** @type {((inputs?: _Field_Schwerbehinderungid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Schwerbehinderungid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Nachweis der Schwerbehinderung")
});
export { _field_schwerbehinderungid2 as "_field_schwerbehinderungID" }